export default "__VITE_ASSET__a6416f00__"